<template>
  <main>
    <h2 class="ttl">{{$t('accountPhoto')}}</h2>
    <div id="user-area2">
      <img class="user-photo" :src="profilePhotoURL">
      <p class="mt30">
        <router-link to="" @click.native="deletePhoto" v-if="this.user.photoURL">{{$t('delete')}}<img src="/img/ico_arrow.png" alt="矢印" width="20" class="ml10"></router-link>
      </p>
    </div>
    <p v-if="errorMessage">{{ errorMessage }}</p>
    <input id="avator-input" ref="fileInput" class="photo-input" type="file" accept="image/png,image/jpeg" @change="uploadPhoto">
    <p class="btn-normal">
      <router-link to="#" @click.native="selectPhoto">{{$t('chooseFromLibrary')}}</router-link>
    </p>
  </main>
</template>

<script>
import firebase from 'firebase'
import accountProfileIcon from "@/assets/img/icon-account-profile.jpg"
import loadImage from 'blueimp-load-image'

export default {
  name: 'AccountPhoto',
  data () {
    return {
      user: firebase.auth().currentUser,
      storage: firebase.storage(),
      profilePhotoURL: null,
      errorMessage: null
    }
  },
  created () {
    this.load()
  },
  methods: {
    load () {
      this.errorMessage = null
      this.profilePhotoURL = this.user.photoURL || accountProfileIcon
    },
    selectPhoto () {
      const input = document.querySelector('#avator-input')
      input.click()
    },
    uploadPhoto (event) {
      event.preventDefault()
      if (event.target.files.length === 0) {
        return null
      }
      const file = event.target.files[0]
      loadImage.parseMetaData(file, (data) => {
        const options = {
          maxHeight: 500,
          maxWidth: 500,
          canvas: true,
        }
        if (data.exif) {
          options.orientation = data.exif.get('Orientation')
        }
        loadImage(file, (canvas) => {
            canvas.toBlob((blob) => {
              this.uploadResizedImage(blob)
            })
        }, options)
        if (this.$refs.fileInput && this.$refs.fileInput.value !== undefined) {
          this.$refs.fileInput.value = '';
        }
      })
    },
    async uploadResizedImage (resizedImg) {
      try {
        const fileRef = this.storage.ref().child('users/' + this.user.uid).child('profile')
        const snapshot = await fileRef.put(resizedImg)
        const downloadURL = await snapshot.ref.getDownloadURL()
        await this.user.updateProfile({ photoURL: downloadURL }).then(() => {
          this.$toasted.success(this.$t('successUploadPhoto'))
          this.load()
        })
      } catch(error) {
        this.errorMessage = this.$t('failUploadPhoto')
      }
    },
    async deletePhoto () {
      if(confirm(this.$t('promptDeletePhoto'))) {
        await this.user.updateProfile({ photoURL: null }).then(() => {
          this.$toasted.success(this.$t('confirmationDeletionPhoto'))
          this.load()
        })
      }
    },
  }
}
</script>

<style scoped>
.photo-input {
  display: none;
}
</style>